export default __webpack_public_path__ + "3f4a9cac7fedd50ed7f23334c8408c1c.svg";